export class ListData {
  pageIndex!: number;
  pageSize!: number;
  totalCount!: number;
  pageData!: {
    reviewId: number,
    active: boolean,
    pageData: {
      reviewId: number
      reviewOwnerIcon: string
      reviewOwnerName: string
      reportId: number
      reportDate: string
      reportNumber: string
      reportedByIcon: string
      reportedByName: string
      reportedByType: SourceTypeEnum
      restaurantId: number
      restaurantIcon: string
      restaurantName: string
    }[]
  }[];
}

export enum DecisionEnum {
  Hide = 'Hide',
  Keep = 'Keep'
}
export class ReportDetails {
  canEditDecision!: boolean
  canMakeDecision!: boolean
  reportId!: number
  reportNumber!: string
  reportReasones!: string
  reportedbyIcon!: string
  reportedbyName!: string
  reportComment!: string
  reportDate!: string
  restaurantId!: any
  reportDecision!: {
    decisionType: DecisionEnum
    resolution: string
    resolutionComment: string
    resolvedDate: string
    resolvedbyIcon: string
    resolvedbyName: string
  }[]
  reviewData!: {
    reservationId: number,
    reservationNumber: string,
    reviewId: number,
    reviewerIcon: string
    reviewerName: string
    restaurantIcon: string
    restaurantName: string
    reviewComment: string
    reviewDate: string
    reviewPhotos: string[]
    reviewRate: number
    reviewVideos: string[]
  }
}

export class ListFilter {
  pageSize!: number;
  pageNumber!: number;
  sortItems!: sortList | null;
  searchText!: string;
  createdFrom!: Date;
  createdTo!: Date;
  phoneNumber!: string;
  resturantID!: number;
  reportedByType!: SourceTypeEnum;
  status!: number;
}
export enum SourceTypeEnum {
  Restaurant = 'Restaurant',
  Customer = 'Customer'
}

export enum sortList {
  NewestCreate = 1,
  OldestCreate = 2,
}

export enum reportTypeEnum {
  Unresolved = 0,
  Resolved = 1
}
